module.exports = "<div [hidden]=\"!chart\" class=\"chart\">\r\n  <canvas id=\"canvas\" #canvas>{{ chart }}</canvas>\r\n  <span class=\"percentage\">{{ totalName }}%</span>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/diagram-round/diagram-round.component.html
// module id = ./src/app/shared/components/diagram-round/diagram-round.component.html
// module chunks = main